import { render, staticRenderFns } from "./LogoTiktokSvg.vue?vue&type=template&id=428c81da"
import script from "./LogoTiktokSvg.vue?vue&type=script&lang=js"
export * from "./LogoTiktokSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports